let ll_enhance_conversions_timer;

function createStyle() {
  const style = document.createElement("style");
  style.id = "ll-enchance-conversions";
  style.innerHTML = `
    #conversions_layers_root {
        opacity: 0;
    }
    `;
  document.querySelector("head").appendChild(style);
}

function clearStyle() {
  const style = document.querySelector("#ll-enchance-conversions");
  style.remove();
}

function bindModal() {
  document.querySelector("body").addEventListener("click", (e) => {
    const target = e.target;
    const container = target.closest(".mars-ui-portal-container.stt-mars1");
    if (target.role === "button" && container) {
      clearStyle();
      if (ll_enhance_conversions_timer) {
        clearTimeout(ll_enhance_conversions_timer);
      }
    }
  });
}

function onMutation(mutationList, observer) {
  // 检查所有的 MutationRecord
  for (var mutation of mutationList) {
    // 如果是新添加的节点
    if (mutation.type === "childList") {
      var addedNodes = mutation.addedNodes; // 获取被添加的节点
      addedNodes.forEach((node) => {
        if (node.id === "conversions_layers_root") {
          const container = document.querySelector("#conversions_layers_root");
          const iframe = container?.querySelector("iframe[src^='/apps/automizely-messages/layers/popup-bars']");

          iframe.onload = () => {
            const iframeDocument = iframe.contentWindow.document;

            let times = 8;

            function trigger() {
              if (times <= 0) {
                clearStyle();
                return;
              }

              const button = iframeDocument.querySelector(".MuiButtonBase-root[aria-label='close']");

              if (button) {
                button.click();
                clearStyle();
              } else {
                ll_enhance_conversions_timer = setTimeout(trigger, 1000);
              }
              times--;
            }

            trigger();
          };
        }
      });
    }
  }
}

function main() {
  const observer = new MutationObserver(onMutation);
  const body = document.querySelector("body");
  const config = { childList: true, subtree: true };
  observer.observe(body, config);

  createStyle();
  bindModal();
}
main();
